const PageContentLoader = ({bgColor}) => {
    return (
        <div className={`content-loader-section ${bgColor ? 'color-main-bg main-content-loader':''}`} >
            <div className="loading-dots">
                <span className="fw-semibold">Loading &nbsp;</span>
                <div className="loading-dots--dot"></div>
                <div className="loading-dots--dot"></div>
                <div className="loading-dots--dot"></div>
            </div>
        </div>
    )
}

export default PageContentLoader